import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "Components/Authentication/AuthProvider";
import { ChildrenProps } from "Utils/types";

/**
 * Holds the authorized tree until the shared provider has resolved the stored session
 * (including the refresh it runs on bootstrap for an expired one), then either renders it or
 * sends the browser to `/login`. Replaces the Redux `TokenValidator` (DEV-6053): the app no
 * longer validates or refreshes tokens itself, so a session that cannot be continued ends in an
 * explicit re-login rather than in API calls sent without a bearer.
 */
export const SessionGate = ({ children }: ChildrenProps) => {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
